import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { TextWithLinkCell } from '~/components/common';

import type { TypePostOrderExcelResponse } from '~/types/order.types';

/**
 * [출고주문관리] 주문 엑셀 일괄 등록 실패 모달 테이블
 */
const getOrderRegisterExcelUploadFailColumnDefs = () => {
  const columnDefs: TypeTableColumn<TypePostOrderExcelResponse['failResults'][number]>[] = [
    {
      id: 'no',
      header: 'No',
      cell: ({ row }) => row.index + 1,
      size: 72,
    },
    {
      accessorKey: 'clientOrderCode',
      header: '판매처 주문번호',
      size: 160,
    },
    {
      accessorKey: 'failReason',
      header: '실패사유',
      minSize: 500,
      cell: ({ getValue }) => <TextWithLinkCell value={getValue<string>()} />,
      // 줄바꿈 행의 상하 여백 9px 을 kitchen 셀 콘텐츠 여백(4px)과 합쳐 맞춘다.
      meta: { flex: true, overflow: 'wrap', cellStyle: { padding: '5px 0' } },
    },
  ];

  return { columnDefs };
};

export default getOrderRegisterExcelUploadFailColumnDefs;
